import { render, staticRenderFns } from "./audio-hero.vue?vue&type=template&id=594507ba&scoped=true&"
import script from "./audio-hero.vue?vue&type=script&lang=js&"
export * from "./audio-hero.vue?vue&type=script&lang=js&"
import style0 from "./audio-hero.vue?vue&type=style&index=0&id=594507ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594507ba",
  null
  
)

export default component.exports